export default __webpack_public_path__ + "static/media/NorwegianFjords.319e167f.jpg";